export default __webpack_public_path__ + "static/media/beauty-2.4e6f0f8d.png";